import React from 'react'
import { Grid, GridItem } from '@deal/components'
import DesktopNavigationSubSection from '../DesktopNavigationSubSection'
import { DepartmentNavigationTopLevelItemFragment } from '#src/generated/graphql'
import classnames from 'classnames'
import styles from './styles.css'

interface DesktopTertiaryNavProps extends React.HTMLAttributes<HTMLElement> {
  item: DepartmentNavigationTopLevelItemFragment
  // A callback to fire when any link is clicked in the menu
  onLinkClick?: React.MouseEventHandler
}

/**
 * This serves as the third-level nav for desktop users.
 *
 * The panel's content is related to a selected category:
 *   - Browsing sub-categories
 *   - Searching via recommended facets (brand, location, etc.)
 *   - Shopping with a category expert
 */
const DesktopTertiaryNav: React.SFC<DesktopTertiaryNavProps> = ({
  item,
  onLinkClick,
  className
}) => {
  return (
    <nav className={classnames(styles.nav, className)}>
      <Grid className={styles.content}>
        <GridItem col={2} className={styles.category}>
          {item.subSections.filter(section => section.showIfFullSize).map(section => {
            return (
              <DesktopNavigationSubSection
                section={section}
                onLinkClick={onLinkClick}
                key={section.id}
              />
            )
          })}
        </GridItem>
      </Grid>
    </nav>
  )
}

export default DesktopTertiaryNav
